import React from 'react';
import axios from 'axios';
import {Button, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import {withRouter} from "react-router-dom";

class ForgottenPasswordForm extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            inProcess: false,
            done: false,
            values: {
                email: ''
            },
            validation: {
                states: {
                    email: null
                },
                messages: {
                    email: ''
                }
            }
        };

        this.requestReset = this.requestReset.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].classList.remove('nav-md');
        document.getElementsByTagName('body')[0].classList.add('login');
    }

    componentWillUnmount() {
        document.getElementsByTagName('body')[0].classList.remove('login');
        document.getElementsByTagName('body')[0].classList.add('nav-md');
    }

    handleChangeEmail(event) {
        let email =  event ? event.target.value : this.state.values.email;

        let values = this.state.values;
        values.email = email;

        let validation = this.state.validation;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(email)) {
            validation.states.email = "success";
            validation.messages.email = '';
        } else {
            validation.states.email = "error";
            validation.messages.email = 'Zkontrolujte formát e-mailu!'
        }

        this.setState({
            values,
            validation
        });
    }

    isValid() {
        this.handleChangeEmail();
        let {validation} = this.state;
        let error = Object.values(validation.states);
        return error.indexOf("error") < 0;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            this.setState({
                inProcess: true,
                done: false
            });
            this.requestReset(this.state.values);
        }
    }

    requestReset(values) {
        axios.put(this.props.api.requestPasswordReset, values)
            .then((res) => {
                console.log('Uloženo!', res);
                this.setState({
                    inProcess: false,
                    done: true
                });
            }).catch((error) => {
            console.error('Axios error:', error);
            alert('Chyba komunikace. Opakujte akci později.');
            this.setState({
                inProcess: false,
                done: false
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {}
    componentWillReceiveProps(nextProps) {}

    render() {
        const {done, inProcess, values, validation} = this.state;
        return (
            <div className="login-wrapper">
                <div className="animate form login-form">
                    <section className="login-content">
                        <Form onSubmit={this.handleSubmit}>
                            <h1>Zapomenuté heslo</h1>
                            <div id="sending" className={inProcess && !done ? "show" : "hide"}>
                                odesílání...
                            </div>
                            <div id="sent" className={done ? "show" : "hide"}>
                                požadavek odeslán, pokračujte dle pokynů, které odbdržíte na zadanou emailovou adresu
                            </div>
                            <div className={inProcess || done ? "hide" : "show"}>
                                <FormGroup controlId="email" validationState={validation.states.email}>
                                    <FormControl type="email" onChange={this.handleChangeEmail} value={values.email} placeholder="Zadejte email"/>
                                    <HelpBlock>{validation.messages.email}</HelpBlock>
                                </FormGroup>
                            </div>
                            <Button type='submit' className={done ? "hide" : "show-inline"} bsStyle="success">Získat heslo</Button>
                            <div className="separator">
                                <div>
                                    <h1>
                                        <i className="fa fa-paw"/>
                                        {' '}
                                        Nebourám.cz
                                    </h1>
                                    <p>©{new Date().getFullYear()} Všechna práva vyhrazena. Nebourám.cz</p>
                                </div>
                            </div>
                        </Form>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(ForgottenPasswordForm);


/** WEBPACK FOOTER **
 ** ./src/containers/ForgottenPassword/ForgottenPasswordForm.js
 **/